"use client";

import ImportFromPapers from "@/components/subjects/ImportFromPapers";
import { UploadPlugin, UploadPluginRenderProps } from "./plugin-interface";
import { getUploadMessages } from "../locales/messages";
import { PaperId, Paper } from "@/stores/slices/paperSlice";

const messages = getUploadMessages();

/** ImportPlugin 的配置类型 */
export interface ImportPluginConfig {
  /** 导入文献的回调函数 */
  onImport?: (paperIds: PaperId[], papers: Paper[]) => Promise<boolean>;
  /** 最大可导入文献数量（用于限制导入数量，仅在特定场景下使用，如工作流创建） */
  maxNumOfPapers?: number;
  /** 已导入的文献数量（用于计算剩余可导入数量，仅在特定场景下使用，如工作流创建） */
  importedNumOfPapers?: number;
}

const ImportPluginTrigger = ({ config, pluginConfig, onSubDialogChange }: UploadPluginRenderProps) => {
  const importConfig = pluginConfig as ImportPluginConfig | undefined;
  return (
    <ImportFromPapers
      buttonClassName="min-w-[130px]"
      // 只在 pluginConfig 中明确指定时才传递限制参数
      // 默认情况下不传递，让 ImportFromPapers 使用默认值（0 和 -1），这样就不会触发限制检查
      maxNumOfPapers={importConfig?.maxNumOfPapers}
      importedNumOfPapers={importConfig?.importedNumOfPapers}
      onImport={importConfig?.onImport}
      onOpenChange={(open) => {
        // 通知父级 Dialog 子 Dialog 的状态变化
        if (onSubDialogChange) {
          onSubDialogChange(open);
        }
      }}
    />
  );
};

/** 默认的 importPlugin（不包含配置） */
export const importPlugin: UploadPlugin = {
  id: "import",
  name: messages.buttons.importFromLibrary,
  source: "import",
  renderTrigger: (props) => <ImportPluginTrigger {...props} />,
  isSupported: (context) => Boolean(context.subjectId),
};

